"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import { Component, Vue, Ref } from "vue-property-decorator";
import ElPhoneVerifyCodeInput from "../framework/components/form/ElPhoneVerifyCodeInput.vue";
import Validator from "../framework/components/form/validator";
import API from "@ym-framework/api-utils";
const Fingerprint2 = require("fingerprintjs2");
const md5 = require("md5");
import { Base64 } from "js-base64";
import nocaptcha from "vue-nocaptcha/lib/nocaptcha.js";
let TeamInviteRegister = class extends Vue {
  constructor() {
    super(...arguments);
    this.teamName = null;
    this.teamCode = null;
    this.status = "ready";
    this.send_lock = true;
    this.rules = {
      nickname: [
        {
          required: true,
          message: "\u6635\u79F0\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165",
          trigger: "blur"
        }
      ],
      phone: [
        {
          required: true,
          message: "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165",
          trigger: "blur"
        },
        { validator: Validator.phone, trigger: "blur" }
      ],
      password: [
        {
          required: true,
          message: "\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165\u3002",
          trigger: "blur"
        },
        {
          min: 6,
          max: 24,
          message: "\u5F53\u524D\u5BC6\u7801\u957F\u5EA6\u4E0D\u6B63\u786E\uFF0C\u5E94\u4E3A6\u523024\u4F4D",
          trigger: "blur"
        },
        { validator: Validator.password, trigger: "blur" }
      ],
      verify_code: [
        {
          required: true,
          message: "\u6821\u9A8C\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165\u3002",
          trigger: "blur"
        }
      ],
      unlock: [{ required: true, message: "\u8BF7\u6ED1\u52A8\u9A8C\u8BC1", trigger: "blur" }]
    };
    this.formData = {
      nickname: "",
      phone: "",
      password: "",
      verify_code: "",
      unlock: "",
      remark: null
    };
    this.verify_result = {};
    this.verify = null;
    this.nohide = "no-captcha nc-container";
    this.showRegisterDialog = false;
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("code")) {
        this.teamCode = this.$route.query.code;
      } else {
        this.$router.push("/");
        return;
      }
      yield this.getTeamName();
      let _components = yield Fingerprint2.getPromise({
        fonts: { extendedJsFonts: true }
      });
      let _dist = {};
      for (let _item of _components) {
        _dist[_item.key] = _item.value;
      }
      let _speed = [
        _dist["audio"],
        _dist["availableScreenResolution"],
        _dist["colorDepth"],
        _dist["deviceMemory"],
        _dist["hardwareConcurrency"],
        _dist["plugins"],
        _dist["timezone"],
        _dist["userAgent"],
        _dist["canvas"],
        _dist["webgl"],
        _dist["webglVendorAndRenderer"]
      ];
      let _user_id = md5(Base64.encode(_speed.toString()));
      let _verify = yield API.get(
        "api://base.app/api/v1/security_verify/custom/register",
        {
          params: {
            user_id: _user_id.toUpperCase()
          }
        }
      );
      this.verify = _verify.data.token;
      yield this.unlockEvent();
    });
  }
  onLoad() {
    console.log("loaded");
  }
  onError() {
    console.log("error");
  }
  getTeamName() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.app/api/v1/team/code/${this.teamCode}`
        );
        this.teamName = response.data.name;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  unlockEvent() {
    return __async(this, null, function* () {
      this.formData.unlock = true;
      this.nohide = "no-captcha nc-container nohide";
      let _components = yield Fingerprint2.getPromise({
        fonts: { extendedJsFonts: true }
      });
      let _dist = {};
      for (let _item of _components) {
        _dist[_item.key] = _item.value;
      }
      let _speed = [
        _dist["audio"],
        _dist["availableScreenResolution"],
        _dist["colorDepth"],
        _dist["deviceMemory"],
        _dist["hardwareConcurrency"],
        _dist["plugins"],
        _dist["timezone"],
        _dist["userAgent"],
        _dist["canvas"],
        _dist["webgl"],
        _dist["webglVendorAndRenderer"]
      ];
      try {
        let _verify = yield API.post(
          "api://base.app/api/v1/security_verify/custom/get_params",
          {
            data: Base64.encode(_speed.toString()),
            token: this.verify
          }
        );
        this.send_lock = false;
        this.verify_result = {
          challenge: _verify.data.challenge,
          seccode: _verify.data.seccode,
          token: this.verify,
          validate: _verify.data.validate
        };
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  sendPhoneCode(lock) {
    return __async(this, null, function* () {
      try {
        let validPhone = true;
        yield this._teamInviteForm.validateField("phone", (errorMessage) => {
          validPhone = errorMessage === "";
        });
        if (validPhone) {
          yield API.post(
            "api://base.app/api/v1/security_verify/custom/verify_and_send_verifycode",
            __spreadValues({
              code_type: 0,
              phone: this.formData.phone
            }, this.verify_result)
          );
          this.$message(
            "\u9A8C\u8BC1\u7801\u77ED\u606F\u5DF2\u7ECF\u53D1\u9001\u81F3:" + this.formData.phone + "\u8BF7\u6CE8\u610F\u67E5\u6536"
          );
          lock(120);
        }
      } catch (error) {
        if (error.response.data.errors.datas[0].code === "account.virtualphone.register.fail") {
          this.showRegisterDialog = true;
        } else {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  registerTipBtn() {
    this.showRegisterDialog = false;
  }
  contectToTip() {
    window.open(`https://www.kuajingvs.com/contact`, "_blank");
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (yield this._teamInviteForm.validate()) {
          this.status = "submit";
          let _components = yield Fingerprint2.getPromise({
            fonts: { extendedJsFonts: true }
          });
          let _dist = {};
          for (let _item of _components) {
            _dist[_item.key] = _item.value;
          }
          let _speed = [
            _dist["audio"],
            _dist["availableScreenResolution"],
            _dist["colorDepth"],
            _dist["deviceMemory"],
            _dist["hardwareConcurrency"],
            _dist["plugins"],
            _dist["timezone"],
            _dist["userAgent"],
            _dist["canvas"],
            _dist["webgl"],
            _dist["webglVendorAndRenderer"]
          ];
          let _user_id = md5(Base64.encode(_speed.toString()));
          let response = yield API.post(`api://base.app/api/v6/register`, {
            auth_id: this.formData.phone,
            user_name: this.formData.nickname,
            captcha: this.formData.verify_code,
            remark: this.formData.remark,
            device_mini: _user_id,
            device_name: _user_id,
            invite_code: this.teamCode,
            password: this.formData.password,
            platform: "web",
            type: "invite.join.team"
          });
          this.status = "ready";
          if (response.data.model === "account.session.joined.await") {
            this.$router.push({
              path: "/team_invite/success",
              query: this.$route.query
            });
            return;
          }
          if (response.data.model === "account.session.joined.notallow") {
            this.$router.push({
              path: "/team_invite/register_success",
              query: this.$route.query
            });
            return;
          }
          if (response.data.model === "account.session.joined.notallowowner") {
            this.$router.push({
              path: "/team_invite/failed",
              query: this.$route.query
            });
            return;
          }
          if (response.data.model === "account.session.joined") {
            this.$router.push({
              path: "/team_invite/success",
              query: this.$route.query
            });
            return;
          }
          this.$router.push({
            path: "/team_invite/failed",
            query: this.$route.query
          });
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  clicktologin() {
    this.$router.push({
      path: "/team_invite/login",
      query: this.$route.query
    });
  }
};
__decorateClass([
  Ref("teamInviteForm")
], TeamInviteRegister.prototype, "_teamInviteForm", 2);
TeamInviteRegister = __decorateClass([
  Component({
    components: {
      PasswordInput,
      ElPhoneVerifyCodeInput,
      nocaptcha
    }
  })
], TeamInviteRegister);
export {
  TeamInviteRegister as default
};
